import React from 'react';
import PropTypes from 'prop-types';
import { getImgixUrl, getBrandImageUrl } from 'ck-utils';
import { getPriceString } from 'ck-utils/price';
import { Columns } from 'ui-base';
import classnames from 'classnames';
import styles from './SearchBar.module.scss';

const renderPrice = hit => {
  const { price, compareAtPrice, priceVaries } = hit;
  const priceString = getPriceString(price, priceVaries);
  const isSoldOutButStayInCollection = !hit.inStock && hit.tags.includes('marketing:stay-in-collection');
  const isForcedSoldOut = hit.tags.includes('marketing:force-sold-out');
  const inStoreOnly = hit.tags.includes('marketing:in-store-only');

  if (isForcedSoldOut || isSoldOutButStayInCollection || inStoreOnly) {
    return (
      <div className="product-tile-price-parent">
        <span className="product-price has-text-danger">{inStoreOnly ? 'Offline Only' : 'Sold Out'}</span>
      </div>
    );
  }

  if (compareAtPrice && compareAtPrice > price) {
    const originalPriceString = getPriceString(compareAtPrice, priceVaries);
    return (
      <div className="product-tile-price-parent">
        <span className="product-price product-price--on-sale">Sale {priceString}</span>
        <span className="product-compare-price text--strike">{originalPriceString}</span>
      </div>
    );
  }

  return (
    <div className="product-tile-price-parent">
      <span className="product-price">{priceString}</span>
    </div>
  );
};

const SearchBarProductHits = ({ hits, onProductClick, queryID }) => (
  <Columns breakpoint="desktop">
    {hits.map((hit, index) => {
      const handleClick = onProductClick(hit, queryID, index + 1);
      const clickThroughUrl = `/products/${hit.handle}`;
      return (
        <Columns.Column
          className={classnames('product-tile-container', styles.productHit)}
          desktop={{ size: 2 }}
          key={hit.objectID}
        >
          <div className="is-hidden-touch">
            <div className="product-tile-image-wrapper">
              <a onClick={handleClick} href={clickThroughUrl}>
                <img src={getImgixUrl(hit.image)} alt={hit.title} />
              </a>
            </div>
            <img className="product-tile-brand" alt={hit.vendor} src={getBrandImageUrl(hit.vendor, 'centre')} />
            <h5 className="product-tile-product-title">
              <a href={clickThroughUrl} onClick={handleClick}>
                {hit.shortTitle || hit.title}
              </a>
            </h5>
            {renderPrice(hit)}
          </div>
          <a className="is-hidden-desktop is-flex" href={clickThroughUrl} onClick={handleClick}>
            <div className={styles.mobileImage}>
              <div className={classnames('product-tile-image-wrapper',)}>
                <img src={getImgixUrl(hit.image)} alt={hit.title} />
              </div>
            </div>
            <h5 className={styles.mobileTitle}>{hit.shortTitle || hit.title}</h5>
          </a>
        </Columns.Column>
      );
    })}
  </Columns>
);

SearchBarProductHits.propTypes = {
  hits: PropTypes.array.isRequired,
  onProductClick: PropTypes.func.isRequired,
  queryID: PropTypes.string,
};

SearchBarProductHits.defaultProps = {
  queryID: null,
};

export { SearchBarProductHits };
